<form [formGroup]="form" (ngSubmit)="submitForm()">
  <sgt-modal [title]="title" [settings]="settings">
    <div header>
      <h4 class="modal-title">{{ title }}</h4>
    </div>    
    <div class="py-3 px-2" body>

      <ng-template [ngIf]="usuario">
        <div class="row">
          <div class="form-group col-12">
            <label class="col-form-label">Usuário</label>
            <sgt-avatar
                [settings]="{
                    isShowLabelNameRight: true,
                    fullName: usuario.nome,
                    imageUrl: usuario.avatarUrl
                }">
            </sgt-avatar>           
          </div>
        </div>
        <div class="row">
          <div class="form-group col-12">
            <label for="email" class="col-form-label">E-mail</label>
            <input
              type="text"
              class="form-control"
              id="email"
              name="email"
              [value]="usuario.login"
              disabled
              readonly
            />
          </div>
        </div>
      </ng-template>

      <div class="row">
        <div class="form-group col-12">
          <label for="justificativa" class="col-form-label">Justificativa*</label>
          <textarea
            #justificativaTextarea
            class="form-control"
            id="justificativa"
            name="justificativa"
            formControlName="justificativa"
            placeholder="Digite uma justificativa..."
            rows="5"
            sgtAutosize
          ></textarea>
          <p class="form-text">
            Justificativa pela qual o usuário está sendo reativado. Mínimo de 15 caracteres.
          </p>
          <sgt-form-control-error
              *ngIf="form.controls.justificativa.errors && form.controls.justificativa.errors.required && form.controls.justificativa.dirty"
              msgError="A justificativa é obrigatória">
          </sgt-form-control-error>
          <sgt-form-control-error
              *ngIf="form.controls.justificativa.errors && form.controls.justificativa.errors.minlength"
              msgError="A justificativa deve ter no mínimo 15 caracteres">
          </sgt-form-control-error>          
        </div>
      </div>
    </div>

    <div footer>
      <button
        type="button"
        class="btn btn-light mr-3"
        (click)="closeModal()"
      >
        {{ cancelText }}
      </button>

      <button
        [disabled]="form.invalid"
        type="submit"
        class="btn btn-success"
      >
        {{ confirmText }}
      </button>
    </div>
  </sgt-modal>
</form>
